
document.addEventListener("DOMContentLoaded", function () {
    const BLOGS = [
    'product-guides',
    'fix-advices',
    'comparisons',
    'diagnostics-101',
    'general',
    'news'
    ];

    let allArticles = [];
    let currentIndex = 0;

    Promise.all(
    BLOGS.map(handle =>
        fetch(`/blogs/${handle}?view=json`)
        .then(r => r.json())
    )
    )
    .then(results => {
        allArticles = results.flat();
        allArticles.sort(
            (a, b) => b.published_at - a.published_at
        );

        const container = document.getElementById('allBlogsGrid');
        let pagesize = parseInt(container.dataset.pagesize);

        renderNext(pagesize);

        document.getElementById('loadMoreBtn').addEventListener('click', () => {
            renderNext(pagesize);
        });

    });

    function renderNext(count) {
        const container = document.getElementById('allBlogsGrid');

        const items = allArticles.slice(
            currentIndex,
            currentIndex + count
        );

        items.forEach(article => {
            container.insertAdjacentHTML(
                'beforeend',
                `
                <div class="col-xl-4 col-md-6 mb-5 blogpost-item">
                    <div class="w-article">
                        <a href="${ article.url }" class="stretched-link"></a>
                        <div class="article-img">
                            <img 
                                src="${article.image == null ? 'https://cdn.shopify.com/s/files/1/0964/5103/5454/files/no-image.jpg?v=1782116288' : article.image}"  width="auto" height="auto"
                                alt="${article.title}"
                                loading="lazy"
                            >
                        </div>
                        <div class="article-item">
                            <p class="article-category">${article.blog}</p>
                            <h4>${article.title}</h4>
                            <p class="article-date">${article.published_date}</p>
                        </div>                    
                    </div>
                </div>
                `
            );
        });

        currentIndex += count;

        if (currentIndex >= allArticles.length) {
            document.getElementById('loadMoreBtn')?.remove();
        }
    }

    function formatOrdinalDate(timestamp) {
        console.log("timestamp: " + timestamp)
        const date = new Date(timestamp * 1000);
        console.log("date: " + date)
        const day = date.getDate();
        const year = date.getFullYear();

        const month = date.toLocaleString('en-US', {
            month: 'long'
        });

        const suffix = (() => {
            if (day > 3 && day < 21) return 'th';

            switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
            }
        })();

        return `${month} ${day}${suffix}, ${year}`;
    }

});